import { render } from "./HeaderNav.vue?vue&type=template&id=20966a74&scoped=true"
import script from "./HeaderNav.vue?vue&type=script&lang=js"
export * from "./HeaderNav.vue?vue&type=script&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=20966a74&scoped=true&lang=css"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/frequency-lists/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20966a74"]])

export default __exports__